import { Link } from 'react-router-dom';
import { useSettings } from '@/context/SettingsContext';

export const Footer = () => {
  const { settings: s } = useSettings();

  return (
    <footer className="bg-[#0E518D] text-white py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-bold mb-3 text-white">{s.footer_title || ''}</h3>
            <p className="text-sm text-white/70 leading-relaxed">{s.footer_description || ''}</p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-3 text-white">{s.footer_contact_title || ''}</h3>
            <p className="text-sm text-white/70">E-Mail: {s.footer_contact_email || ''}</p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-3 text-white">{s.footer_hint_title || ''}</h3>
            <p className="text-sm text-white/70">{s.footer_hint_text || ''}</p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-3 text-white">Rechtliches</h3>
            <nav className="space-y-2" data-testid="footer-legal-links">
              <Link to="/impressum" className="block text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-impressum">Impressum</Link>
              <Link to="/datenschutz" className="block text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-datenschutz">Datenschutz</Link>
              <Link to="/agb" className="block text-sm text-white/70 hover:text-white transition-colors" data-testid="footer-link-agb">AGB</Link>
            </nav>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/20 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-sm text-white/60">{s.footer_text || ''}</p>
          <p className="text-xs text-white/40" data-testid="footer-version">{s.app_version || ''}</p>
        </div>
      </div>
    </footer>
  );
};
